export default __webpack_public_path__ + "static/media/jumpToWxMini.55cc08d9.png";